// import qs from 'qs';
import generateUrls from 'universal-router/generateUrls';
import router from '../router';

export default {
  getUrl: generateUrls(router, {
    pretty: true,
    // stringifyQueryParams: qs.stringify,
  }),
};



// WEBPACK FOOTER //
// ./src/core/url.js